export const PlayIcon = () => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 12.6093V3.39069C4 3.13833 4.08889 2.92664 4.26667 2.75563C4.44444 2.58462 4.65185 2.49941 4.88889 2.5C4.96296 2.5 5.04089 2.51099 5.12267 2.53296C5.20444 2.55493 5.28207 2.58848 5.35555 2.63361L12.6 7.24291C12.7333 7.33198 12.8335 7.44331 12.9004 7.57691C12.9674 7.71052 13.0006 7.85154 13 7.99999C12.9994 8.14844 12.9662 8.28946 12.9004 8.42307C12.8347 8.55667 12.7345 8.66801 12.6 8.75707L5.35555 13.3664C5.28148 13.4109 5.20385 13.4445 5.12267 13.467C5.04148 13.4896 4.96355 13.5006 4.88889 13.5C4.65185 13.5 4.44444 13.4145 4.26667 13.2435C4.08889 13.0724 4 12.8611 4 12.6093Z'
        fill='white'
      />
    </svg>
  )
}
